import { useNavigate } from "react-router-dom";
import Header from "../components/header";
import { useState } from "react";
import {
  FormLabelDesc,
  SmbInfoContainer,
  SmbInfoForm,
  SmbInfoCard,
  SmbInfoNumber,
  SmbInfoQuote,
} from "../components/styles/Smb.styled";
import { Dropdown, Form } from "react-bootstrap";
import { Button } from "../components/styles/SmbButton.styled";
import Datetime from "react-datetime";
import { fetchSaveSmbStep } from "../api/smb";
import moment from "moment";
import AssistantModal from "../components/smb/AssistantModal";
import { Container, Image } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { showCenteredToast } from "../components/CenteredToast";
import Footer from "../components/InfoFooter";
import { toast } from 'react-toastify'

const SmbInfo = () => {
  const navigate = useNavigate();
  const [expireDate, setExpireDate] = useState<any>(null);
  const [selectedTerm, setSelectedTerm] = useState("Short-term");
  const [contractStatus, setContractStatus] = useState("know-date");

  const handleSubmit = async () => {
    if (contractStatus === "know-date" && expireDate === null) {
      console.log("Please select an expire date.")
      toast.error("Please select an expire date.")
      showCenteredToast("Please select an expire date.", {
        onConfirm: () => { },
      });
      return
    }
    if (!selectedTerm) return;
    let formattedExpireDate;

    if (contractStatus === "month-to-month") {
      formattedExpireDate = moment().startOf("month").format("YYYY/MM/DD");
    } else if (contractStatus === "dont-know") {
      formattedExpireDate = moment().add(1, "month").startOf("month").format("YYYY/MM/DD");
    } else {
      formattedExpireDate = moment(expireDate).format("YYYY/MM/DD");
    }
    fetchSaveSmbStep({
      Step: "expire date & preferred term",
      StepData: { expireDate: formattedExpireDate, term: selectedTerm },
    });
    sessionStorage.setItem("smbExpireDate", formattedExpireDate);
    sessionStorage.setItem("smbTerm", selectedTerm);
    navigate(`/smb/process`);
  };

  const handleSkip = async () => {
    const formattedExpireDate = moment().startOf("month").format("YYYY/MM/DD");
    await fetchSaveSmbStep({
      Step: "expire date & preferred term - skip",
    });
    sessionStorage.setItem("smbExpireDate", formattedExpireDate);
    sessionStorage.setItem("smbTerm", "Long-term");
    navigate(`/smb/process`);
  };

  return (
    <>
      <Header />
      <Container>
        <SmbInfoContainer>
          <h3 style={{ marginBottom: "30px",maxWidth:600 }}>Answer a Few Questions to Customize Our Recommendations</h3>
          <SmbInfoForm>
            <SmbInfoCard style={{ marginBottom: "24px" }}>
              <div className="card-title">
                <div className="card-title-number">1</div>
                <span  style={{display:'inline-block', maxWidth:460,width:'100%' }}>Do you know when your current  electricity contract ends?</span>
              </div>
              <div className="info-text">
                <img src="/images/icon-info.png" alt="" width={20} height={20} />
                <div style={{ maxWidth:360 }}>You can find this info on your electricity bill or energy provider's (REP) online account.</div>
              </div>
              <Form className="form-group">
                <div className="custom-radio-wrapper">
                  <label className="custom-radio">
                    <input
                      type="radio"
                      name="contractStatus"
                      value="know-date"
                      checked={contractStatus === "know-date"}
                      onChange={() => {
                        setContractStatus("know-date");
                      }}
                    />
                    <span className="radio-icon"></span>
                    Yes, I know the expiry date
                  </label>

                  {contractStatus === "know-date" && <Datetime
                    value={expireDate}
                    onChange={(date) => setExpireDate(date)}
                    timeFormat={false}
                    inputProps={{
                      placeholder: "DD MM YYYY",
                      style: {
                        paddingLeft: "32px",
                        background: `url('/images/icon-date.png') no-repeat 8px center`,
                        backgroundSize: "16px 16px",
                      }
                    }}
                  />}
                </div>

                <div className="custom-radio-wrapper">
                  <label className="custom-radio">
                    <input
                      type="radio"
                      name="contractStatus"
                      value="month-to-month"
                      checked={contractStatus === "month-to-month"}
                      onChange={() => {
                        setContractStatus("month-to-month");
                        setExpireDate(null);
                      }}
                    />
                    <span className="radio-icon"></span>
                    I'm on a month-to-month contract
                  </label>
                </div>

                <div className="custom-radio-wrapper">
                  <label className="custom-radio">
                    <input
                      type="radio"
                      name="contractStatus"
                      value="dont-know"
                      checked={contractStatus === "dont-know"}
                      onChange={() => {
                        setContractStatus("dont-know");
                        setExpireDate(null);
                      }}
                    />
                    <span className="radio-icon"></span>
                    I don't know when my contract expires
                  </label>
                </div>
              </Form>
            </SmbInfoCard>
            <SmbInfoCard>
              <div className="card-title">
                <div className="card-title-number">2</div>
                <span>Which type of plan do you prefer?</span>
              </div>
              <Form className="form-group">
                <div className="custom-radio-wrapper">
                  <label className="custom-radio">
                    <input
                      type="radio"
                      name="planPreference"
                      checked={selectedTerm === "Short-term"}
                      onChange={() => setSelectedTerm("Short-term")}
                    />
                    <span className="radio-icon"></span>
                    I want a short-term plan (0–6 months)
                  </label>
                </div>

                <div className="custom-radio-wrapper">
                  <label className="custom-radio">
                    <input
                      type="radio"
                      name="planPreference"
                      checked={selectedTerm === "Long-term"}
                      onChange={() => setSelectedTerm("Long-term")}
                    />
                    <span className="radio-icon"></span>
                    I want a long-term plan (6 months or more)
                  </label>
                </div>

                <div className="custom-radio-wrapper">
                  <label className="custom-radio">
                    <input
                      type="radio"
                      name="planPreference"
                      checked={selectedTerm === "All-plans"}
                      onChange={() => setSelectedTerm("All-plans")}
                    />
                    <span className="radio-icon"></span>
                    I want to see all available plans
                  </label>
                </div>
              </Form>
            </SmbInfoCard>
            <div style={{ marginTop: "56px", display: "flex", flexDirection: "row-reverse", gap: "16px" }}>
              <Button onClick={handleSubmit}>Continue</Button>
              <Button variant="secondary" onClick={handleSkip}>Skip</Button>
            </div>
          </SmbInfoForm>
        </SmbInfoContainer>
      </Container>
      <Footer></Footer>
    </>
  );
};

export default SmbInfo;